import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { transformReviewsTemplateToUseProductForContextIfNecessary } from "./defaultComponentTemplate";

export const stampedProductReviewsWidget: ComponentTemplate = {
  id: "145e6418-edd1-42b3-81fb-f568b8f4edbc",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Stamped Product Reviews",
  leftBarCategory: { main: "productIntegrations", subCategory: "stamped" },
  preview: "integrations/stamped-product-reviews.svg",
  transforms: [transformReviewsTemplateToUseProductForContextIfNecessary],
  tags: ["widget"],
  template: {
    id: "$uid",
    type: "stampedProductReviewsWidget",
    props: { style: { alignSelf: "stretch" } },
  },
};
